export const SIMULATION = {
  PHYSICS_INTERVAL_MS: 100,
  POLLING_INTERVAL_MS: 3500,
  AUTO_SAVE_INTERVAL_MS: 30000,
  RAMP_UP_SPEED: 0.6,
  RAMP_DOWN_SPEED: 0.9,
  FREQ_MIN: 0,
  FREQ_MAX: 66,
  FREQ_STEP: 0.5,
  LOAD_MAX: 150,
  LOAD_STEP: 5,
  VOLTAGE_DROP_MAX: 100,
  VOLTAGE_DROP_STEP: 5,
  IMBALANCE_MAX: 30,
  DAYS_OFFLINE_MAX: 730,
};

export const MODBUS = {
  DEFAULT_SLAVE_ID: 1,
  DEFAULT_BAUD_RATE: 9600,
  DEFAULT_PARITY: 'none' as const,
  DEFAULT_STOP_BITS: 1 as const,
  DEFAULT_DATA_BITS: 8 as const,
  READ_TIMEOUT_MS: 2000,
  RETRY_COUNT: 3,
};

export const PREDICTIVE = {
  FAN_MAIN_MAX_HOURS: 50000,
  FAN_CTRL_MAX_HOURS: 30000,
  CAP_REFORMING_WARN_DAYS: 180,
  CAP_REFORMING_CRITICAL_DAYS: 365,
};

export const COLORS = {
  OK: '#00ff9d',
  WARN: '#ffb700',
  DANGER: '#ff4757',
  INFO: '#00d9ff',
};
